import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bistro_send.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-568167e4")

_pushScopeId("data-v-568167e4")
const _hoisted_1 = { class: "detail-instruction-item-description-area" }
const _hoisted_2 = { class: "detail-instruction-item-image-area" }
const _hoisted_3 = { class: "detail-instruction-item-note-area" }
const _hoisted_4 = { class: "detail-instruction-item-appliance-header-area" }
const _hoisted_5 = { class: "detail-instruction-item-appliance-category-area" }
const _hoisted_6 = { class: "detail-instruction-item-appliance-category-label" }
const _hoisted_7 = { class: "detail-instruction-item-bistro-send-area" }
const _hoisted_8 = { class: "detail-instruction-item-bistro-send-view-area" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "detail-instruction-item-bistro-send-icon",
  src: _imports_0
}, null, -1)
const _hoisted_10 = { class: "detail-instruction-item-bistro-send-text" }
const _hoisted_11 = { class: "detail-instruction-item-bistro-send-link-view" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("からIot家電としてご登録いただくと、調理設定を機器へ送信できるようになります。 ")
const _hoisted_13 = { class: "detail-instruction-item-bistro-send-link-view" }
const _hoisted_14 = { class: "commonRecepiDetailDivider" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _mergeProps({
    class: "detail-instruction-item",
    ref: "instructionView"
  }, _ctx.updateDetail), [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        ref: "descriptionText",
        class: "detail-instruction-item-description-view",
        innerHTML: _ctx.description
      }, null, 8, ["innerHTML"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("img", {
        class: "detail-instruction-item-image-view",
        src: _ctx.imageUrl,
        style: _ctx.styleImage
      }, null, 12, ["src"])
    ], 512), [
      [_vShow, _ctx.imageUrl]
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_ctx.getCategoryIcon(_ctx.applianceCategoryId))
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "detail-instruction-item-appliance-category-icon",
                src: _ctx.getCategoryIcon(_ctx.applianceCategoryId)
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.applianceCategory), 1)
        ])
      ]),
      _createVNode("div", {
        innerHTML: _ctx.note,
        class: "detail-instruction-item-note-view"
      }, null, 8, ["innerHTML"]),
      _withDirectives(_createVNode("div", _hoisted_7, [
        _createVNode("div", {
          class: _ctx.getClassBistroSendView(),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBistroSend(...args)))
        }, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.getBistroMessage()), 1)
          ])
        ], 2),
        _withDirectives(_createVNode("div", _hoisted_11, [
          _createVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickBistroSendLinkAppliance()))
          }, "こちら"),
          _hoisted_12
        ], 512), [
          [_vShow, _ctx.bistroSendLink]
        ]),
        _withDirectives(_createVNode("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.getAttachmentName()) + "をご購入いただき、", 1 /* TEXT */),
          _createVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickBistroSendLinkAttachment()))
          }, "こちら"),
          _createTextVNode("からご登録いただくと、" + _toDisplayString(_ctx.getAttachmentName()) + "を使ったレシピを機器へ送信できるようになります。 ", 1 /* TEXT */)
        ], 512), [
          [_vShow, _ctx.bistroSendLinkAttachment]
        ])
      ], 512), [
        [_vShow, _ctx.isShowBistroSend()]
      ])
    ], 512), [
      [_vShow, _ctx.isShowNote()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_14, null, 512), [
      [_vShow, _ctx.isShowDivider()]
    ])
  ], 16))
})